import { useAuth } from '../context/AuthContext';
import { CLTCalculator } from '../services/cltCalculator';

export const useCLTCalculator = () => {
    const { user } = useAuth();
    
    const calculator = new CLTCalculator(
        user?.company?.benefits || {
            valeTransporteDiario: 14.70,
            valeRefeicaoDiario: 32.89,
            valeAlimentacaoDiario: 21.74,
            auxilioSaudeMensal: 500.00,
            diasUteisMedia: 21,
            descontoVTPercentual: 6.0
        },
        user?.company?.tax_config || {
            inssPatronal: 20.0,
            ratSat: 2.0,
            inssTerceiros: 5.8,
            salarioEducacao: 2.5,
            fgts: 8.0,
            inssRanges: [
                { faixa: 1, aliquota: 7.5, tetoFaixa: 1320.00 },
                { faixa: 2, aliquota: 9.0, tetoFaixa: 2571.29 },
                { faixa: 3, aliquota: 12.0, tetoFaixa: 3856.94 },
                { faixa: 4, aliquota: 14.0, tetoFaixa: 7507.49 }
            ],
            irpfRanges: [
                { faixa: 1, aliquota: 0.0, deducao: 0.00, tetoFaixa: 2112.00 },
                { faixa: 2, aliquota: 7.5, deducao: 158.40, tetoFaixa: 2826.65 },
                { faixa: 3, aliquota: 15.0, deducao: 370.40, tetoFaixa: 3751.05 },
                { faixa: 4, aliquota: 22.5, deducao: 651.73, tetoFaixa: 4664.68 },
                { faixa: 5, aliquota: 27.5, deducao: 884.96, tetoFaixa: Infinity }
            ]
        }
    );

    return calculator;
}; 